import { ESuburbanEstimationCategory } from '@cian/valuation-main-filters-widget';
import { IApplicationState } from '../../types/redux';

export function selectFilters(state: IApplicationState) {
  return state.filters;
}

export const selectHouseId = (state: IApplicationState) => state.filters.houseId;
export const selectCategory = (state: IApplicationState) => state.filters.category;
export const selectAddress = (state: IApplicationState) => state.filters.address;
export const selectIsSuburban = (state: IApplicationState) => {
  const { category } = state.filters;

  return Boolean(
    category && [ESuburbanEstimationCategory.HouseSale, ESuburbanEstimationCategory.LandSale].includes(category),
  );
};
